import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../images/services-usa/nft-new/nft_standards_back.webp";
import { StaticImage } from "gatsby-plugin-image";

function Nftstandards() {
  return (
    <section
      className="nft_standards p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center"
          >
            <h2>NFT Standards We Follow</h2>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-5">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="nft_standard_main">
              <div className="nft_standard_item">
                <div className="nft_standard_box">
                  <StaticImage
                    src="../../images/services-usa/nft-new/erc.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={111}
                    height={193}
                  />
                </div>
                <h5>ERC - 721</h5>
              </div>
              <div className="nft_standard_item">
                <div className="nft_standard_box">
                  <StaticImage
                    src="../../images/services-usa/nft-new/erc.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={111}
                    height={193}
                  />
                </div>
                <h5>ERC - 1155</h5>
              </div>
              <div className="nft_standard_item">
                <div className="nft_standard_box">
                  <StaticImage
                    src="../../images/services-usa/nft-new/erc.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={111}
                    height={193}
                  />
                </div>
                <h5>EIP - 2309</h5>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Nftstandards;
